/**
 *判断是否微信
 */
export const is_weixin = (function () {
  return navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1
})()

/**
* 判断是否qq
*/
export const is_qq = (function () {
  var u = navigator.userAgent.toLowerCase()
  return !!u.match(/QQ\/[0-9]/i)
})()

/**
 * @param {String} title title name
 */
export function setTitle(title) {
  document.title = title;
  const iframe = document.createElement('iframe');
  iframe.style.visibility = 'hidden';
  iframe.style.width = '1px';
  iframe.style.height = '1px';
  const iframeCallback = () => {
    setTimeout(() => {
      iframe.removeEventListener('load', iframeCallback);
      document.body.removeChild(iframe);
    }, 0);
  };
  iframe.addEventListener('load', iframeCallback);
  document.body.appendChild(iframe);
}



// WEBPACK FOOTER //
// ./src/utils/index.js